import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

export const ACTION_NAME = 'action/resetdropDownSelectedAddressDetail';

/**
 * Reset address detail to blank object when user closing the modal.
 * @param {object} state
 */
export const ResetCanadaPostAddressDetail = () => ({
    type: ACTION_NAME,
});

/**
 * Fired off when the ResetCanadaPostAddressDetail is called.
 * @param {object} state
 * @param {object} action
 */
export const reducer = produce((state) => {
    state.CanadaPostAddress.dropDownSelectedAddressDetail = {};
});

registerReducer(ACTION_NAME, reducer);
